import React from 'react';
import ArrowLeft from '@deliveroo/icon-set/react/ArrowLeft';
import Cross from '@deliveroo/icon-set/react/Cross';
import Icon from '@deliveroo/consumer-component-library/components/Icon';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Heading from '../../atoms/Heading';
import styles from './styles.scss';

export default function ModalTitle({ title, header, iframe, heart, text, hidePrevious, onClose }) {
  const onBack = () => window.history.back();

  return (
    <div className={classnames({ [styles.modal]: iframe, [styles.heart]: heart })}>
      <div className={styles.top}>
        <Heading tag="h1" className={styles.title}>
          {title}
        </Heading>
        {!hidePrevious && (
          <button type="button" className={styles.back} onClick={onBack}>
            <Icon component={ArrowLeft} size={24} />
          </button>
        )}

        <button type="button" className={styles.close} onClick={onClose}>
          <Icon component={Cross} size={24} />
        </button>
      </div>
      {header && <p className={styles.header}>{header}</p>}
      {text && (
        <p
          className={classnames(styles.text, { [styles.modal]: iframe })}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: text,
          }}
        />
      )}
    </div>
  );
}

ModalTitle.defaultProps = {
  header: null,
  iframe: false,
  hidePrevious: false,
  heart: false,
  text: null,
};

ModalTitle.propTypes = {
  title: PropTypes.string.isRequired,
  header: PropTypes.string,
  iframe: PropTypes.bool,
  hidePrevious: PropTypes.bool,
  heart: PropTypes.bool,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  onClose: PropTypes.func.isRequired,
};
